//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rule',
  props: {},
  data () {
    return {}
  },
  created () { },
  mounted () { },
  methods: {
  }
}
